export interface SalesContractLineSelect {
  id: string;
  contractNo: number;
  productKey: string;
  productDescription: string;
  unitOfMeasure: string;
  contractLineBalance: number;
  price: number;
  expiryDate: string;
  availableDate: string;
}
